<script lang="ts" setup>
import { UModalConfirm } from "#components";

const { t } = useI18n();
const toast = useToast();
const modal = useModal();
const shapesStore = useShapesStore();
const telestrationStore = useTelestrationStore();
const canClear = computed(() => shapesStore.shapes.length > 0);

const { execute: onClearAll } = useAsyncState(
  async () => {
    shapesStore.clearShapes();

    const currentPlaylistItem = telestrationStore.currentPlaylistItem;
    const currentPlaylistItemId = telestrationStore.currentPlaylistItem?.id;
    const currentPlaylistId = currentPlaylistItem?.playlistId;
    const currentTelestration = telestrationStore.currentTelestration;

    if (!currentPlaylistId || !currentPlaylistItemId || !currentPlaylistItem || !currentTelestration) {
      console.warn("No playlist ID, active playlist item, or current telestration");
      return;
    }

    return deletePlaylistItemTelestration(currentPlaylistId, currentPlaylistItemId, currentTelestration.id);
  },
  null,
  {
    immediate: false,
    onSuccess: () => {
      toast.success(t("pages.playlists.telestrations.telestration_delete_success"));
      telestrationStore.exitTelestrationMode();
    },
    onError: (err) => {
      console.error(err);
      return toast.error(parseErrorMessage(err, { t }));
    },
  }
);

const onClick = () => {
  modal.open(UModalConfirm, {
    heading: t("pages.playlists.telestrations.telestration_delete_heading"),
    icon: "telestration",
    variant: "delete",
    description: t("pages.playlists.telestrations.telestration_delete_confirm"),
    confirmFn: () => onClearAll(),
    confirmLabel: t("labels.clear_all"),
    teleportTarget: "#pixellotPlayer",
    cancelLabel: t("labels.cancel"),
  });
};
</script>

<template>
  <TButton
    :icon="{ name: 'delete', class: 'size-4' }"
    :tooltip="t('labels.clear_all')"
    :disabled="!canClear"
    class="hover:bg-blue-500 disabled:hover:bg-transparent"
    @click="onClick"
  />
</template>
